import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Heading,
    AspectRatio,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import { link } from 'fs';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611876&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - ERP',
};

const integrations = [
    {
        id: 0,
        title: 'Subiekt GT',
        link: 'https://www.idosell.com/pl/subiekt-gt-i-subiekt-nexo/',
        description:
            'Subiekt GT to intuicyjny system magazynowo-handlowy dla małych i średnich sklepów.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611701&ext=.png',
            alt: 'Logo Comarch ERP',
        },
    },
    {
        id: 1,
        title: 'Subiekt Nexo',
        link: 'https://www.idosell.com/pl/subiekt-gt-i-subiekt-nexo/',
        description:
            'Subiekt Nexo to nowoczesne oprogramowanie ERP, które łączy prostotę obsługi z zaawansowanymi funkcjami zarządzania sprzedażą i magazynem.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611702&ext=.png',
            alt: 'Logo Comarch ERP',
        },
    },
    {
        id: 2,
        title: 'Comarch ERP Optima',
        link: 'https://www.idosell.com/pl/comarch-erp-optima/',
        description:
            'Comarch ERP Optima to jedno z najczęściej wybieranych rozwiązań w Polsce, stworzone z myślą o małych i średnich sklepach z różnych branż.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611703&ext=.png',
            alt: 'Logo Symfonia ERP',
        },
    },
    {
        id: 3,
        title: 'WAPRO Mag',
        link: 'https://www.idosell.com/pl/wapro-mag/',
        description:
            'WAPRO Mag oferuje zaawansowane funkcje zarządzania sprzedażą, cennikami, rabatami oraz kontrolą zobowiązań i należności, wspierając zarówno sprzedaż offline, jak i online.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611704&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 4,
        title: 'Enova365',
        link: 'https://www.idosell.com/pl/enova365/',
        description:
            'Enova365 to nowoczesny system ERP, który został stworzony, żeby maksymalizować efektywność sklepów internetowych.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611705&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 5,
        title: 'Streamsoft Prestiż',
        link: 'https://www.idosell.com/pl/streamsoft/',
        description:
            'Streamsoft Prestiż ujednolica rozwiązania informatyczne w firmie i porządkuje procesy biznesowe, zapewniając spójność danych oraz pełną kontrolę nad procesami.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611706&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 6,
        title: 'Symfonia Handel',
        link: 'https://www.idosell.com/pl/idosell-bridge-integruje-subiekt-gt-subiekt-nexo-wapro-mag-dawniej-wf-mag-streamsoft-prestiz-comarch-erp-optima-enova365-kazdy-inny-erp/lista-obslugiwanych-programow-erp-/-f-k-/symfonia/',
        description:
            'Symfonia Handel to elastyczne oprogramowanie ERP, które wspiera sprzedaż, zarządzanie magazynem, dokumentami i płatnościami oraz ułatwia obsługę klientów.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611708&ext=.png',
            alt: 'Logo Optima ERP',
        },
    },
    {
        id: 7,
        title: 'Inne systemy ERP',
        link: 'https://www.idosell.com/pl/developers/uniwersalny-tryb-pracy-udb-w-aplikacji-idosell-bridge-do-integracji-sklepu-internetowego-z-erp/',
        description:
            'Zintegruj dowolny system ERP ze swoim sklepem internetowym i automatycznie zarządzaj danymi o produktach, zamówieniach i stanach magazynowych.',
        image: {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611709&ext=.png',
            alt: 'Inne ERP',
        },
    },
];

export default function AffiliatePageComponent(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Program partnerski i lojalnościowy w IdoSell"
                subTitle="Wzmocnij relacje z klientami i buduj długoterminowe przychody dzięki elastycznym programom lojalnościowym i partnerskim – wszystko w ramach Twojego sklepu na IdoSell."
                image={heroImage}
                paddingDesktop="75px 0"
                gap="0"
            />
            <div className="homepage containerIdosellPages">
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: 'unset' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611879&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611878&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                alignItems={'flex-start'}
                                width={{ base: '100%', lg: '50%' }}
                                flex={'1'}
                                padding={'30ox'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Program Partnerski w IdoSell – zarabiaj na poleceniach
                                </Text>
                                <Text
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    fontSize={'18px'}
                                    marginBottom={'15px'}
                                >
                                    Zachęć klientów do promowania Twojego sklepu i nagradzaj ich za
                                    skuteczne polecenia.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'30px'}>
                                    Współpracuj z influencerami, blogerami i wydawcami treści,
                                    którzy wypromują Twój sklep w social mediach, na blogach czy
                                    YouTube. W zamian otrzymają oni prowizję za każde zamówienie –
                                    płacisz tylko za efekty (model PPS).
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'45px'}>
                                    To skuteczna i długofalowa strategia, która generuje stały ruch
                                    i nowych klientów. Program partnerski jest skutecznym sposobem
                                    na rozwój sklepu bez dużych nakładów pracy.
                                </Text>
                                <Link
                                    href="https://pomoc.idosell.com/marketing-i-promocje/program-partnerski"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    target="_blank"
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Dowiedz się więcej
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row-reverse' }}
                        >
                            <Box width={{ base: '100%', width: '370px' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611880&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611881&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box width={{ base: '100%', lg: '50%' }} flex={'1'} padding={'30px'}>
                                <Text
                                    fontSize={{ base: '25px', lg: '34px' }}
                                    fontWeight="semibold"
                                    className="text-wrapper-2"
                                    color="#1AAC7A"
                                    marginBottom={'30px'}
                                >
                                    Dotrzyj do nowych klientów i zwiększ sprzedaż z Programem
                                    Partnerskim
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Gotowe reklamy
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Partnerzy mogą łatwo generować banery reklamowe
                                                i umieszczać je na swoich stronach. Zaawansowani
                                                użytkownicy mają dostęp do kodów PHP i JavaScript.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Różne formy wynagrodzenia
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Swoich partnerów możesz wynagrodzić w zróżnicowany
                                                sposób - gotówką, punktami lojalnościowymi, kodami
                                                rabatowymi lub bonami zakupowymi.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Pełna kontrola
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Sprawdzaj efektywność działań wszystkich partnerów
                                                z możliwością ich sortowania.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Elastyczność i wygoda
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Zdecyduj, od których zamówień partner ma otrzymać
                                                prowizję. Dodatkowo, możesz ustawić prowizję tylko
                                                dla nowych klientów.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Zarządzanie wypłatami
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Moduł wypłat gotówkowych i opcja opóźnienia prowizji
                                                (np. po 14 dniach, co pozwala uniknąć wypłat
                                                prowizji za zamówienie, które może zostać zwrócone).
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: 'unset' }} maxW={'50%'}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611882&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611883&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                alignItems={'flex-start'}
                                width={{ base: '100%', lg: '50%' }}
                                flex={'1'}
                                padding={'30ox'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Program Lojalnościowy w IdoSell – zatrzymaj klientów na dłużej
                                </Text>
                                <Text
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    fontSize={'18px'}
                                    marginBottom={'15px'}
                                >
                                    Zwiększ lojalność klientów i buduj z nimi długoterminową relację
                                    bez dodatkowych kosztów!
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'30px'}>
                                    Program lojalnościowy IdoSell umożliwia łatwe nagradzanie i
                                    zachęcanie do kolejnych zakupów. Przyznawaj punkty, które można
                                    wymieniać na produkty, rabaty, darmową dostawę i inne nagrody.
                                    To doskonały sposób na zwiększenie liczby powracających klientów
                                    i budowanie ich lojalności, bez potrzeby inwestowania
                                    w dodatkowe reklamy.
                                </Text>
                                <Link
                                    href="https://www.idosell.com/pl/program-lojalnosciowy-sklepu-internetowego/"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    target="_blank"
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Dowiedz się więcej
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <TilesSection
                    title={
                        'Program lojalnościowy w IdoSell to więcej lojalnych klientów w Twoim sklepie'
                    }
                    tiles={[
                        {
                            title: 'Spójne doświadczenie w wielu kanałach',
                            content:
                                'Nagradzaj lojalnych klientów w wielu kanałach sprzedaży, oferując nowoczesne narzędzia promocji, takie jak karty stałego klienta, bony towarowe czy karty podarunkowe. Poznaj aplikację IdoSell POS.',
                        },
                        {
                            title: 'Prosta konfiguracja w kilku kliknięciach',
                            content:
                                'Uruchom program lojalnościowy bez zbędnych komplikacji – wystarczy kilka kliknięć, żeby zacząć nagradzać swoich klientów.',
                        },
                        {
                            title: 'Dopasowane nagrody dla lojalnych klientów',
                            content:
                                'Określ przelicznik punktów i oferuj szeroki wybór nagród: od produktów, przez rabaty, po darmową dostawę.',
                        },
                        {
                            title: 'Łatwe zarządzanie programem',
                            content:
                                'Zarządzaj programem lojalnościowym, kontroluj salda punktów i modyfikuj ustawienia za pomocą prostego panelu',
                        },
                        {
                            title: 'Wiele sklepów, wspólne punkty',
                            content:
                                'W przypadku korzystania z opcji multistore punkty zbierane są na koncie klienta wspólnie, ale dla każdego sklepu można ustawiać osobno przeliczniki.',
                        },
                        {
                            title: 'Więcej powracających klientów',
                            content:
                                'Motywuj klientów do kolejnych zakupów, umożliwiając im wymianę punktów na atrakcyjne rabaty lub darmową dostawę.',
                        },
                    ]}
                />
                <ContactSection mb={'50px'} />
            </div>
        </ThemeProvider>
    );
}
